<template>
  <div class="page-main">
    <div class="page-header">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">{{team.name}}</li>
        <li class="breadcrumb-item active">Settings</li>
      </ol>
      <h1 class="page-title">Rename</h1>
      <div class="page-header-actions">
        <button type="button" class="btn btn-primary">
          <i class="icon md-plus" aria-hidden="true"></i> <span class="text hidden-sm-down"> Add User</span>
        </button>
      </div>
    </div>
    <div class="page-content">
      <div class="panel">
        <div class="panel-body">
          <form v-on:submit.prevent="onSubmit">
            <div class="row">
              <div class="col-md-6">
                <div class="form-section">
                <form-group v-bind:error="formErrors.first('name')">
                  <label for="username">Name</label>
                  <input type="text" class="form-control input-lg" id="name" placeholder="Name" v-model="team.name">
                </form-group>
                <form-group v-bind:error="formErrors.first('namespace')">
                  <label for="name">Namespace</label>
                  <input type="text" class="form-control input-lg" id="namespace" placeholder="Name space" v-model="team.namespace" disabled>
                </form-group>
                </div>
              </div>
            </div>
            <button type="submit" class="btn btn-success" :disabled="isSubmiting" v-bind:class="{ 'btn-default': isSubmiting }">
              <div class="loader vertical-align-middle loader-circle loader-form" v-if="isSubmiting"></div> Submit
            </button>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { Validator } from 'vee-validate';
import FormGroup from 'components/forms/FormGroup';

export default {
  components: {
    FormGroup,
  },
  watch: {
    'team.name': function(value) {
      this.validator.validateAll({
        name: value,
      }).catch(() => {});
    },
  },
  data: function () {
    return {
      isSubmiting: false,
      hasUser: false,
      validator: null,
      formErrors: null,
      step: 'information',
      team: {
        id: 1,
        name: 'ByteArk',
        namespace: 'https://accounts.byteark.com/byteark',
        owner: { id: 90, username: 'bongbank', password: 'bongbank', team: 'inox' },
        owner_id: 2,
        reseller: 0,
        reseller_id: 0,
      },
      users: [],
    };
  },
  created: function() {
    this.validator = new Validator({
      name: 'required',
    });

    this.$set(this, 'formErrors', this.validator.errorBag);
  },
  mounted: function() {
    this.fetchUsers();
  },
  methods: {
    onSubmit: function () {
      this.validator.validateAll({
        team: this.team.name,
      })
      .then((success) => {
        if (!success) {
          return;
        }

        this.isSubmiting = true;
        axios.put(`/inox/admin/teams/${this.team.namespace}/edit`, {
          team: this.team.name,
        })
        .then((response) => {
          this.isSubmiting = false;
          this.team = response.data;
        })
        .catch(() => {
          this.isSubmiting = false;
          // TODO: show error message from api
        });
      })
      .catch(() => {
        this.isSubmiting = false;
        // TODO:
      });
    },
    fetchUsers: function() {
      axios.get(`/api/teams/${this.$route.params.namespace}/users`)
        .then((response) => {
          this.users = response.data.data;
        })
        .catch(() => {

        });
    },
    swapTab: function(value) {
      this.step = value;
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// TeamDeactivate.vue?65023316